import React, {
  useState,
  useEffect,
  useContext,
  forwardRef,
  useImperativeHandle
} from 'react'
import classNames from 'classnames'

import ModalContext from '../context/ModalContext'
import ModalV2 from './ModalV2'
import withModal from './withModal'
import TmoButton from '../tmoButtons/TmoButton'
import TmoCheckbox from '../tmoForms/TmoCheckbox'
import useWindowWidth from '../tmoHooks/useWindowWidth'
import TmoSvg from '../tmoUiHelpers/TmoSvg'
import { DIMENSIONS } from '../tmoUtilities/constants'

import style from './FilterModal.module.css'

const FilterModal = withModal(function FilterModal({
  buttonText,
  onFilter,
  openModal,
  options,
  originalList,
  inputRef,
  renderIcon,
  testId,
  isActionIconBtn
}) {
  const [formSpecs, setFormSpecs] = useState()
  const { closeModal } = useContext(ModalContext)
  const windowWidth = useWindowWidth()
  const handleSelection = (data) => {
    if (data?.target?.value) {
      let temp = [...formSpecs]
      var key = data.target.getAttribute('data-name')
      let category = temp.filter((x) => x.key === key)[0]
      let selectedValues = category.selectedValues

      if (data.target.checked) {
        if (!selectedValues.includes(data.target.value)) {
          if (data.target.value === 'null') {
            let valueCheck = originalList?.filter(
              (f) => f[key] === data.target.value
            )
            if (valueCheck.length === 0) {
              selectedValues.push(null)
              setFormSpecs(temp)
            } else {
              selectedValues.push(data.target.value)
              setFormSpecs(temp)
            }
          } else {
            selectedValues.push(data.target.value)
            setFormSpecs(temp)
          }
        }
      } else {
        const index = selectedValues.indexOf(data.target.value)
        if (index > -1) {
          selectedValues.splice(index, 1)
          setFormSpecs(temp)
        } else {
          if (data.target.value === 'null') {
            const i = selectedValues.indexOf(null)
            if (i > -1) {
              selectedValues.splice(i, 1)
              setFormSpecs(temp)
            }
          }
        }
      }
    }
  }

  const buildFilter = () => {
    let query = {}
    for (let i = 0; i < formSpecs.length; i++) {
      if (
        formSpecs[i].selectedValues.constructor === Array &&
        formSpecs[i].selectedValues.length > 0
      ) {
        query[formSpecs[i].key] = formSpecs[i].selectedValues
      }
    }
    return query
  }

  const FilterData = (filteredList) => {
    let list = filteredList !== undefined ? filteredList : originalList
    let query = buildFilter()
    return list.filter((item) => {
      for (let key in query) {
        if (item[key] === null) {
          if (!query[key].includes(item[key])) {
            return false
          } else {
            return true
          }
        }
        if (
          item[key] === undefined ||
          !query[key].includes(item[key].toString())
        ) {
          return false
        }
      }
      return true
    })
  }

  const handleFilterClick = () => {
    let result = FilterData()
    onFilter({ list: result, parentEvent: false })
    closeModal()
  }

  useImperativeHandle(inputRef, () => ({
    ApplyFilters(filteredList) {
      let result = FilterData(filteredList)
      onFilter({ list: result, parentEvent: true })
    }
  }))

  useEffect(() => {
    if (options && originalList) {
      let optionList = []
      options.forEach((option) => {
        let values = Array.from(
          new Set(originalList?.map((f) => f[option.key]))
        )
        if (values && values.length) {
          let temp = {}
          temp.key = option.key
          temp.displayName = option.value
          temp.values = Array.from(
            new Set(
              originalList?.map((f) =>
                f[option.key] !== null ? f[option.key].toString() : null
              )
            )
          )
          temp.selectedValues = Array.from(
            new Set(
              originalList?.map((f) =>
                f[option.key] !== null ? f[option.key].toString() : null
              )
            )
          )
          optionList = [...optionList, temp]
        }
      })
      setFormSpecs([...optionList])
    }
  }, [options, originalList, setFormSpecs])

  return (
    <React.Fragment>
      <TmoButton
        className={classNames(
          style.button,
          (!originalList || originalList.length === 0) && style.disabled
        )}
        type={isActionIconBtn ? 'magenta_icon_btn' : 'magenta_secondary_icon'}
        tooltip={windowWidth <= DIMENSIONS.MOBILE_WIDTH && 'Filter'}
        icon={
          windowWidth <= DIMENSIONS.MOBILE_WIDTH ? (
            <TmoSvg className={style.mobile_icon} svgId='icon-filter' />
          ) : (
            renderIcon
          )
        }
        onClick={openModal}
        disabled={!originalList || originalList.length === 0}
        data-testid={testId}
      >
        {windowWidth > DIMENSIONS.MOBILE_WIDTH && 'Filter'}
      </TmoButton>
      <ModalV2 title='filter' portal={true} modalType='slide' modalSize='md'>
        <div className={style.content}>
          <div className={style.scrollable_content}>
            {formSpecs?.length > 0 &&
              formSpecs.map((e, index) => (
                <div key={`${e.key}-${index}`} className={style.wrapper}>
                  <div className={style.category_name}>{e.displayName}</div>
                  {e.values?.length > 0 &&
                    e.values.map((v, index) => (
                      <TmoCheckbox
                        key={`${v !== null ? v.key : 'null-null'}-${index}`}
                        value={v === null ? 'null' : v}
                        isChecked={e.selectedValues.includes(v)}
                        onChange={(e) => handleSelection(e)}
                        data-name={e.key}
                        checkbox='magentaCheckbox'
                      />
                    ))}
                </div>
              ))}
          </div>
          <div className={style.footer_wrapper}>
            <TmoButton
              onClick={closeModal}
              icon={
                <TmoSvg
                  className={style.button_icon}
                  svgId='icon-close-modal'
                />
              }
              type='magenta_secondary'
              position='top'
            >
              Cancel
            </TmoButton>
            <TmoButton
              icon={
                <TmoSvg
                  className={style.button_icon}
                  svgId='icon-check-modal'
                />
              }
              onClick={handleFilterClick}
              type='magenta_primary'
              position='top'
            >
              {buttonText ? buttonText : 'Apply Filter'}
            </TmoButton>
          </div>
        </div>
      </ModalV2>
    </React.Fragment>
  )
})

export default forwardRef((props, ref) => {
  return <FilterModal {...props} inputRef={ref} />
})
